import { C, fonts } from "../theme.js";
import { SectionLabel, Hex } from "./primitives.jsx";
import { SERVICES } from "../content.js";

const ServiceCard = ({ idx, title, body, accent }) => (
  <div
    className="service-card"
    style={{
      position: "relative",
      background: C.card,
      border: `1px solid ${C.border}`,
      borderRadius: 8,
      padding: "32px 28px",
      display: "flex",
      flexDirection: "column",
      gap: 18,
      minHeight: 260,
      transition: "transform 200ms ease, border-color 200ms ease, box-shadow 200ms ease",
      overflow: "hidden",
    }}
  >
    <div
      className="service-bar"
      style={{
        position: "absolute",
        left: 0,
        top: 0,
        bottom: 0,
        width: 0,
        background: accent,
        transition: "width 220ms ease",
        boxShadow: `0 0 18px ${accent}`,
      }}
    />
    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
      <Hex size={26} accent={accent} />
      <span style={{ fontFamily: fonts.mono, fontSize: 11, color: C.faint, letterSpacing: "0.16em" }}>
        0{idx + 1}
      </span>
    </div>
    <h3
      style={{
        margin: 0,
        fontFamily: fonts.serif,
        fontSize: 26,
        fontWeight: 500,
        color: C.fg,
        lineHeight: 1.15,
        letterSpacing: "-0.005em",
      }}
    >
      {title}
    </h3>
    <p style={{ margin: 0, fontFamily: fonts.sans, fontSize: 14, lineHeight: 1.65, color: C.body }}>
      {body}
    </p>
  </div>
);

export const Services = ({ accent }) => (
  <section id="services" style={{ background: C.bg, padding: "140px 40px" }}>
    <div style={{ maxWidth: 1280, margin: "0 auto" }}>
      <div
        style={{
          display: "flex",
          alignItems: "flex-end",
          justifyContent: "space-between",
          flexWrap: "wrap",
          gap: 24,
          marginBottom: 56,
        }}
      >
        <div style={{ display: "flex", flexDirection: "column", gap: 14 }}>
          <SectionLabel accent={accent}>// SERVICES</SectionLabel>
          <h2
            style={{
              margin: 0,
              fontFamily: fonts.serif,
              fontSize: "clamp(36px, 4.4vw, 56px)",
              fontWeight: 500,
              color: C.fg,
              letterSpacing: "-0.01em",
              lineHeight: 1.05,
            }}
          >
            What we build.
          </h2>
        </div>
        <p
          style={{
            margin: 0,
            fontFamily: fonts.mono,
            fontSize: 13,
            color: C.body,
            maxWidth: 360,
            lineHeight: 1.65,
          }}
        >
          Six practice areas. Project-based engagements, technical advisory, and embedded AI engineering.
        </p>
      </div>
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(320px, 1fr))",
          gap: 20,
        }}
      >
        {SERVICES.map(([t, b], i) => (
          <ServiceCard key={i} idx={i} title={t} body={b} accent={accent} />
        ))}
      </div>
    </div>
  </section>
);
